import Nav from "./../Page/Share/Nav/Nav";
const Post8 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Glowy Cosmetics Branding & Packaging
          </h2>
          {/* items?.Description */}
          <p>
            Glowy is a high-quality skincare product developed by an experienced dermatologist to renovate and maintain a healthy skin & hair barrier. Glowy enters the high-competitive marketplace narrowed to only 3 products, targeting busy and career-driven women who are leading an active lifestyle.

            That is a very important first for Glowy, a luxury and hydrating skincare & hair line. We are thrilled to bring it to the market and offer women highly effective skincare products in an affordable range that helps to safeguard and protect their skin and gives it a healthy glow. Inspired by the clean formula and pure ingredients of the product, we designed a logo emblem that gives a shine to the skin and hair. We wanted to emphasize the transformation and change by giving the emblem a glossy effect. We used this idea strongly in corporate identity and packaging designs.
          </p>
          {/* img section */}
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/40bfdf159979225.63aaaa668361e.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/771a22159979225.63aaaa668a0b8.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/9db6da159979225.63aaaa668511b.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/9e91e5159979225.63aaaa6688152.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/643815159979225.63aaaa6690119.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/c051fe159979225.63aaaa668c25e.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/a4c2b7159979225.63aaaa667b298.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/431ade159979225.63aaaa668911f.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/e399b4159979225.63aaaa668260f.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/9223ad159979225.63aaaa667ec18.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/74b20b159979225.63aaaa667fc9c.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/31b264159979225.63aaaa668e183.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/59a43e159979225.63aaaa667d7b3.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/45b19e159979225.63aaaa667802c.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/a530e3159979225.63aaaa667907c.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/5ec151159979225.63aaaa668f015.jpg" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post8;
